import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ProductModel } from "src/app/models/product.model";
import { MathService } from "src/app/services/math/math.service";
import { ProductService } from "src/app/services/product/product.service";

/**
 * Generated class for the DayCalendarComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: "amount-editor",
  templateUrl: "amount-editor.component.html",
  styleUrls: ["./amount-editor.component.scss"]
})
export class AmountEditorComponent implements OnInit {
  _basket:any = {
    quantity:0,
    quantityDelivery:0,
    volumeDelivered:0,
    totalPriceVATIncluded:0,
    totalPriceVATIncludedSmallDecimal:0,
    unitPriceVATIncluded:0,
    unitPriceVATIncludedSmallDecimal:0,
    amountStatus:'setByProducer'
  }

  _priceChanged =false;
  _totalChanged = false;
  _quantityChanged = false;
  _weightChanged = false;

  focus = 'volumeDelivered';

  _product:ProductModel = {
    details:{
      unitPriceQuantityMetric:'kilogram',
      unitPriceQuantityMetricType:'weight',
      quantityMetric:'gram',
      quantityMetricType:'weight',
      quantityIncrement:100,
      quantityMin:100,
      quantityMax:10000,
      unitPriceVATIncluded:5,
      currency:'EUR'
    },
    basket:{
      quantity:1500,
      totalPriceVATIncluded:7.5
    }
  }

  get product(): ProductModel {
    return this._product;
  }
  @Input('product')
  set product (value:ProductModel){
    this._product = value;
    this._basket = {...value.basket, 
      quantityDelivered:value.basket.quantityDelivered>=0?value.basket.quantityDelivered:value.basket.quantity,
      volumeDelivered:value.basket.volumeDelivered || ((value.details.unitPriceQuantityMetricType == 'weight' && value.details.quantityMetricType == 'weight')?value.basket.quantity:null),
      unitPriceVATIncluded:value.basket.unitPriceVATIncluded>=0?value.basket.unitPriceVATIncluded:value.details.unitPriceVATIncluded,
      unitPriceVATIncludedSmallDecimal:this.mathService.convertAmountToSmallestCurrencyDecimal(value.basket.unitPriceVATIncluded>=0?value.basket.unitPriceVATIncluded:value.details.unitPriceVATIncluded,value.details.currency),
      totalPriceVATIncludedSmallDecimal:this.mathService.convertAmountToSmallestCurrencyDecimal(value.basket.totalPriceVATIncluded,value.details.currency)
    };
    if(value.details.unitPriceQuantityMetricType =='piece'){
      this.focus = 'quantityDelivered';
    }
    else if(value.details.unitPriceQuantityMetricType =='none'){
      this.focus = 'total';
    }
    else{
      this._product.basket.volumeDeliveredMetric ='gram';
    }
    console.log(this._product, this._basket)
  }

  @Input()
  public onValidate = (basket) => {}

  @Output() quantityValidated = new EventEmitter<ProductModel>();

  constructor(public mathService:MathService, private productService:ProductService) {}

  ngOnInit() {}

  onClick(value){
    let valueStr = '';
    let quantityStr = '';
    if(this.focus=='quantityDelivered'){
      if(this._basket.quantityDelivered){
        quantityStr = this._basket.quantityDelivered.toString();
      }
      if(this._quantityChanged){
        quantityStr += value.toString();
      }
      else{
        quantityStr = value.toString();
      }
      this._quantityChanged = true;
      this._basket.quantityDelivered = parseFloat(quantityStr);
      this._basket.totalPriceVATIncluded = this.mathService.calculateProductTotalAmount({
        details:this._product.details, basket:this._basket
      });
      this._basket.totals = this.mathService.calculateProductTotalsAmount({
        details:this._product.details, basket:this._basket
      })
    }
    else if (this.focus =='volumeDelivered'){
      if(this._basket.volumeDelivered){
        quantityStr = this._basket.volumeDelivered.toString();
      } 
      if(this._weightChanged){
        quantityStr += value.toString();
      }
      else{
        quantityStr = value.toString();
      }
      if(this._basket.quantityDelivered === 0){
        this._basket.quantityDelivered = this._basket.quantity;
      }
      this._weightChanged = true;
      this._basket.volumeDelivered = parseFloat(quantityStr);
      this._basket.totalPriceVATIncluded = this.mathService.calculateProductTotalAmount({
        details:this._product.details, basket:this._basket
      });
    }
    else if (this.focus =='price'){
      if(this._basket.unitPriceVATIncluded){
        quantityStr = this._basket.unitPriceVATIncludedSmallDecimal.toString();
      }
      if(this._priceChanged){
        quantityStr += value.toString();
      }
      else{
        quantityStr = value.toString();
      }
      this._priceChanged = true;
      this._basket.unitPriceVATIncludedSmallDecimal = parseFloat(quantityStr);
      this._basket.unitPriceVATIncluded = this.mathService.convertAmountToIntCurrency(this._basket.unitPriceVATIncludedSmallDecimal, this._product.details.currency);
      this._basket.totalPriceVATIncluded = this.mathService.calculateProductTotalAmount({
        details:this._product.details, basket:this._basket
      });
    }
    else if (this.focus =='total'){
      if(this._basket.totalPriceVATIncluded){
        quantityStr = this._basket.totalPriceVATIncludedSmallDecimal.toString();
      }
      if(this._totalChanged){
        quantityStr += value.toString();
      }
      else{
        quantityStr = value.toString();
      }
      this._totalChanged = true;
      this._basket.totalPriceVATIncludedSmallDecimal = parseFloat(quantityStr);
      this._basket.totalPriceVATIncluded = this.mathService.convertAmountToIntCurrency(this._basket.totalPriceVATIncludedSmallDecimal, this._product.details.currency);
      this._basket.unitPriceVATIncluded = this.mathService.calculateProductPrice({      
        details:this._product.details, basket:this._basket
      });
      // console.log(this._basket);
    }
  }
  onErase(){
    let valueStr = '';
    let quantityStr = '';

    if(this.focus=='quantityDelivered'){
      if(this._basket.quantity){
        quantityStr = this._basket.quantityDelivered.toString();
        quantityStr = quantityStr.slice(0, -1);
        this._quantityChanged = true;
        if(quantityStr.length == 0){
          this._basket.quantityDelivered = 0;
          if(this._basket.volumeDelivered){
            this._basket.volumeDelivered = 0;
          }
        }
        else{
          this._basket.quantityDelivered = parseFloat(quantityStr);
        }
      }
      this._basket.totalPriceVATIncluded = this.mathService.calculateProductTotalAmount({
        details:this._product.details, basket:this._basket
      });
    }
    else if (this.focus =='volumeDelivered'){
      if(this._basket.volumeDelivered){
        quantityStr = this._basket.volumeDelivered.toString();
        quantityStr = quantityStr.slice(0, -1);
        this._weightChanged = true;
        if(quantityStr.length == 0){
          this._basket.volumeDelivered = 0;
          this._basket.quantityDelivered = 0;
        }
        else{
          this._basket.volumeDelivered = parseFloat(quantityStr);
        }
      }
      this._basket.totalPriceVATIncluded = this.mathService.calculateProductTotalAmount({
        details:this._product.details, basket:this._basket
      });
    }
    else if (this.focus =='price'){
      if(this._basket.unitPriceVATIncluded){
        quantityStr = this._basket.unitPriceVATIncludedSmallDecimal.toString();
        quantityStr = quantityStr.slice(0, -1);
        this._priceChanged = true;
        if(quantityStr.length == 0){
          this._basket.unitPriceVATIncludedSmallDecimal = 0;
        }
        else{
          this._basket.unitPriceVATIncludedSmallDecimal = parseFloat(quantityStr);
        }
      }
      this._basket.unitPriceVATIncluded = this.mathService.convertAmountToIntCurrency(this._basket.unitPriceVATIncludedSmallDecimal, this._product.details.currency);
      this._basket.totalPriceVATIncluded = this.mathService.calculateProductTotalAmount({
        details:this._product.details, basket:this._basket
      });
    }
    else if (this.focus =='total'){
      if(this._basket.totalPriceVATIncluded){
        quantityStr = this._basket.totalPriceVATIncludedSmallDecimal.toString();
        quantityStr = quantityStr.slice(0, -1);
        this._totalChanged = true;
        if(quantityStr.length == 0){
          this._basket.totalPriceVATIncludedSmallDecimal = 0;
        }
        else{
          this._basket.totalPriceVATIncludedSmallDecimal = parseFloat(quantityStr);
        }
        this._basket.totalPriceVATIncluded = this.mathService.convertAmountToIntCurrency(this._basket.totalPriceVATIncludedSmallDecimal, this._product.details.currency);
        this._basket.unitPriceVATIncluded = this.mathService.calculateProductPrice({      
          details:this._product.details, basket:this._basket
        });
      }
    }
  }

  onClickValidate(){
    this._basket.amountStatus = 'setByProducer';
    this.onValidate(this._basket);
    this.quantityValidated.emit(this._product);
  }
  refocus(focus:string){
    this.focus = focus;
    this._priceChanged = false;
    this._quantityChanged = false;
    this._totalChanged = false;
    this._weightChanged = false;
  }
}
